function escapeHtml(value) {
  return String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char] || char));
}

export function createPlaybackPopupWindow(openWindow = (...args) => window.open(...args)) {
  const popupFeatures = [
    'popup=yes',
    'resizable=yes',
    'scrollbars=yes',
    'toolbar=no',
    'menubar=no',
    'location=no',
    'status=no'
  ].join(',');

  return openWindow('about:blank', '_blank', popupFeatures);
}

export function writePlaybackPopupMessage(popup, message, title, { showTitle = true } = {}) {
  if (!popup) {
    return;
  }

  try {
    const escapedMessage = escapeHtml(message);
    const titleMarkup = showTitle ? `<p class="title">${escapeHtml(title)}</p>` : '';

    popup.document.open();
    popup.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Media Playback</title><style>body{font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;background:#111827;color:#e5e7eb;margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh;padding:24px;text-align:center} .card{max-width:560px;background:#1f2937;border:1px solid #374151;border-radius:16px;padding:24px;box-shadow:0 20px 50px rgba(0,0,0,.35)} .title{font-size:20px;font-weight:700;margin:0 0 12px} .message{font-size:15px;line-height:1.6;margin:0;white-space:pre-wrap}</style></head><body><div class="card">${titleMarkup}<p class="message">${escapedMessage}</p></div></body></html>`);
    popup.document.close();
  } catch {
    // Ignore popup write failures.
  }
}

export function showPlaybackPreparingState(popup, uiMessages) {
  writePlaybackPopupMessage(popup, uiMessages.playbackPreparingText, uiMessages.playbackPreparingTitle, { showTitle: false });
}

export async function resolvePlaybackUrl({ caseId, mediaId, isInternalZoneRequest = false, managementApiService, getFirstRecordValue, uiMessages }) {
  const response = await managementApiService.getPlaybackUrl({
    caseId,
    mediaId,
    isInternalZoneRequest
  });
  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const errorMessage = payload?.message || payload?.error?.message || uiMessages.playbackOpenFailed;
    throw new Error(errorMessage);
  }

  const responseData = payload?.data ?? payload ?? null;
  const playbackUrl = getFirstRecordValue(responseData, ['playbackUrl', 'PlaybackUrl']);
  if (!playbackUrl) {
    throw new Error(uiMessages.playbackMissingUrl);
  }

  return playbackUrl;
}

export async function openPlaybackPopupUrl({ popup, playbackUrl, screenObject = window.screen }) {
  if (!popup) {
    return;
  }

  try {
    popup.moveTo(0, 0);
    popup.resizeTo(screenObject?.availWidth || 1920, screenObject?.availHeight || 1080);
  } catch {
    // Ignore browser popup sizing restrictions.
  }

  popup.location.href = playbackUrl;

  try {
    popup.focus();
  } catch {
    // Ignore popup focus restrictions.
  }
}
